import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { CartContext } from "./CartContext";
import { FavoritesContext } from "./FavoritesContext";
import { useToast } from "./ToastContext";
import productData from "../Datas/productData";
import "../css/favorites.scss";

const Favorites = () => {
  const { addToCart } = useContext(CartContext);
  const { favorites, removeFromFavorites } = useContext(FavoritesContext);
  const { showToast } = useToast();
  const [addedItems, setAddedItems] = useState([]);

  const favoriteProducts = productData.filter((product) =>
    favorites.includes(product.id)
  );

  const formatPrice = (price) => {
    const numeric = Number(price);
    if (Number.isNaN(numeric)) return price;
    return `€ ${numeric.toLocaleString("en-EU", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  const handleRemove = (productId) => {
    removeFromFavorites(productId);
    showToast("Removed from favorites", "success");
  };

  const handleAddToCart = (product, size) => {
    addToCart(product.id, 1, size);
    setAddedItems([...addedItems, product.id]);
    showToast("Added to cart", "success");
    setTimeout(() => {
      setAddedItems(addedItems.filter((id) => id !== product.id));
    }, 2000);
  };

  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const isVideo = (url) => /\.(mp4|webm|ogg)(\?.*)?$/i.test(url);

  return (
    <div className="favorites-page color-scheme color-scheme--scheme-1">
      <Header />
      <main className="favorites-page__main">
        <div className="favorites-container">
          <h1 className="favorites-title">My Favorites</h1>
          <p className="favorites-count">{favoriteProducts.length} items</p>

          {favoriteProducts.length === 0 ? (
            <div className="favorites-empty">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="64" height="64">
                <path strokeLinecap="round" strokeLinejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z" />
              </svg>
              <p>Your favorites list is empty</p>
              <Link to="/shop" className="favorites-empty__cta" onClick={toTop}>
                Browse Products
              </Link>
            </div>
          ) : (
            <div className="favorites-grid">
              {favoriteProducts.map((product) => (
                <article key={product.id} className="favorite-card">
                  <Link
                    to={`/shopDetails/${product.id}`}
                    className="favorite-card__media"
                    onClick={toTop}
                  >
                    {isVideo(product.images[0]) ? (
                      <video
                        src={product.images[0]}
                        autoPlay
                        muted
                        loop
                        playsInline
                      />
                    ) : (
                      <img src={product.images[0]} alt={product.name} />
                    )}
                    <button
                      type="button"
                      className="favorite-remove"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleRemove(product.id);
                      }}
                      aria-label="Remove from favorites"
                    >
                      <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                        <path d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                      </svg>
                    </button>
                  </Link>

                  <div className="favorite-card__info">
                    <p className="favorite-card__brand">{product.country}</p>
                    <Link
                      to={`/shopDetails/${product.id}`}
                      className="favorite-card__name"
                      onClick={toTop}
                    >
                      {product.name}
                    </Link>
                    <p className="favorite-card__price">{formatPrice(product.price)}</p>

                    {product.size && product.size.length > 0 && (
                      <div className="favorite-card__sizes">
                        {product.size.map((size) => (
                          <span key={size} className="size-tag">
                            {size}
                          </span>
                        ))}
                      </div>
                    )}

                    <button
                      type="button"
                      className={`favorite-add-btn ${
                        addedItems.includes(product.id) ? "is-added" : ""
                      }`}
                      onClick={() =>
                        handleAddToCart(product, product.size?.[0] || "M")
                      }
                      disabled={addedItems.includes(product.id)}
                    >
                      {addedItems.includes(product.id) ? (
                        <>
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                          </svg>
                          Added to Cart
                        </>
                      ) : (
                        <>
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="16" height="16">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
                          </svg>
                          Add to Cart
                        </>
                      )}
                    </button>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Favorites;
